export default __webpack_public_path__ + "static/media/paper.9d5eeedd.png";